import type { ThemeConfig } from 'antd';

const theme: ThemeConfig = {
  token: {
    colorPrimary: '#8B7BA8',
    colorInfo: '#7C9EB2',
    colorSuccess: '#7BBF96',
    colorWarning: '#E5C45A',
    colorError: '#D48888',
    colorBgLayout: '#F8F9FA',
    colorBgContainer: '#FFFFFF',
    colorBorder: '#E8EBF0',
    colorBorderSecondary: '#F3F4F6',
    colorText: '#2D3142',
    colorTextSecondary: '#6B7280',
    colorTextPlaceholder: '#9CA3AF',
    borderRadius: 8,
    borderRadiusLG: 12,
    borderRadiusSM: 6,
    fontFamily: "-apple-system, BlinkMacSystemFont, 'SF Pro Display', 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif",
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.04)',
    boxShadowSecondary: '0 4px 16px rgba(0, 0, 0, 0.06)',
  },
  components: {
    Menu: {
      darkItemBg: 'transparent',
      darkItemSelectedBg: 'rgba(255,255,255,0.08)',
      darkItemHoverBg: 'rgba(255,255,255,0.05)',
      darkItemColor: 'rgba(255,255,255,0.65)',
      darkItemSelectedColor: '#FFFFFF',
      darkItemHoverColor: '#FFFFFF',
    },
    Card: {
      borderRadiusLG: 12,
    },
    Button: {
      borderRadius: 8,
      primaryShadow: '0 4px 12px rgba(139, 123, 168, 0.12)',
    },
    Table: {
      headerBg: '#F9FAFB',
      headerColor: '#2D3142',
      rowHoverBg: '#F9FAFB',
      borderRadius: 8,
    },
    Modal: {
      borderRadiusLG: 16,
    },
    Input: {
      borderRadius: 6,
      colorBorder: '#E8EBF0',
      activeBorderColor: '#8B7BA8',
      activeShadow: '0 0 0 2px rgba(139, 123, 168, 0.08)',
    },
    Select: {
      borderRadius: 6,
      colorBorder: '#E8EBF0',
      activeBorderColor: '#8B7BA8',
    },
  },
};

export default theme;
